import { processRefererString, type ProcessedReferer } from './processReferer'

export type { ProcessedReferer }

/**
 * Client-side entry referrer: `document.referrer`, validated like an HTTP Referer.
 * Persists once per tab in `sessionStorage` so in-SPA navigations do not overwrite.
 */
export function captureDocumentReferrerOnce(
    storageKey = 'nl_doc_referrer_v1',
): ProcessedReferer | null {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return null
    }

    try {
        const raw = sessionStorage.getItem(storageKey)
        if (raw) {
            const parsed = JSON.parse(raw) as ProcessedReferer
            if (parsed && typeof parsed.href === 'string') {
                return parsed
            }
        }
    } catch {
        // ignore corrupt storage
    }

    const processed = processRefererString(document.referrer || undefined)
    if (processed) {
        try {
            sessionStorage.setItem(storageKey, JSON.stringify(processed))
        } catch {
            // quota / private mode
        }
    }
    return processed
}

/** Same as {@link captureDocumentReferrerOnce} — stable name for call sites. */
export function resolveEntryReferrer(storageKey?: string): ProcessedReferer | null {
    return captureDocumentReferrerOnce(storageKey)
}
